import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'localizedName' })
export class LocalizedNamePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value: string | Record<string,string>): string {
        let map: Record<string,string>;

        if (typeof value === 'object' && value !== null) {
            map = value;
        } else if (typeof value === 'string') {
            try {
                map = JSON.parse(value);
            } catch {

                return value;
            }
        } else {
            return String(value);
        }

        const lang = this.translate.currentLang || 'en';

        if (map[lang]) {
            return map[lang];
        }

        const firstKey = Object.keys(map)[0];
        return map[firstKey] ?? '';
    }
}
